/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetLimitModel {
    getFixupPrototypeFunction() { return BudgetLimitModel.fixupPrototype; }

    static newInstance(model: Partial<BudgetLimitModel>): BudgetLimitModel {
        let obj = Object.assign(new BudgetLimitModel(), model);
        BudgetLimitModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetLimitModel>): BudgetLimitModel {
        if (!model) return null;
        return BudgetLimitModel.newInstance(<BudgetLimitModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetLimitModel) {
        if (!obj) return;

        models.BudgetLimitModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetLimitModel): boolean {
        Object.setPrototypeOf(obj, BudgetLimitModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.amount === undefined) {
            this.amount = 0;
        }
    }

    /**
     * budget amount for that period
     */
    amount: number;

    /**
     * month format should be Jun-2015 and for annually 2020
     */
    month: string;

}
